const isLocalhost = window.location.hostname === "localhost";
const tenantId = process.env.REACT_APP_TENANT_ID?.trim() || "c5157762-27d9-4d4b-b703-136ca9854e62";
const clientId = process.env.REACT_APP_CLIENT_ID?.trim() || "df14b28c-4958-468b-b4cd-bdbcec9caa2c";
const apiScope = process.env.REACT_APP_API_SCOPE?.trim();
const apiBaseUrl = process.env.REACT_APP_API_URL?.trim() || "https://socialit-portale-clienti-ggebcne0e0d6gyc3.westeurope-01.azurewebsites.net";

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: isLocalhost
      ? "http://localhost:3000/auth/redirect"
      : "https://customer.socialit.it/auth/redirect",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const apiRequest = {
  scopes: apiScope ? [apiScope] : [],
};

export const hasApiScope = Boolean(apiScope);

export const graphRequest = {
  scopes: ["User.Read"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const apiConfig = {
  baseURL: apiBaseUrl, // "http://localhost:7071", //
  endpoints: {
    clienti: "/api/clienti",
    rapportini: "/api/rapportini",
    commesse: "/api/commesse",
  },
};
